import {Three as THREE} from "@cm/three-texture-streaming/three"
import type {IWebgl2RgbaStaging} from "@cm/three-texture-streaming"

export class OffscreenCanvasWebgl2RgbaStaging implements IWebgl2RgbaStaging {
    private readonly _canvas: OffscreenCanvas
    private readonly _ctx: OffscreenCanvasRenderingContext2D
    private readonly _tex: THREE.Texture

    constructor(width: number, height: number) {
        this._canvas = new OffscreenCanvas(width, height)
        this._ctx = this._canvas.getContext("2d") as OffscreenCanvasRenderingContext2D
        this._tex = new THREE.Texture(this._canvas as unknown as HTMLImageElement)
        this._tex.generateMipmaps = false
        this._tex.colorSpace = THREE.LinearSRGBColorSpace
        this._tex.flipY = false
    }

    getTexture(pixels: Uint8Array, width: number, height: number): THREE.Texture {
        this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height)
        this._ctx.putImageData(new ImageData(new Uint8ClampedArray(pixels.buffer as ArrayBuffer), width, height), 0, 0)
        this._tex.needsUpdate = true
        return this._tex
    }

    dispose(): void {
        this._tex.dispose()
    }
}
